// 繁體中文（台灣）語言包
const zhTW = {
  // 導航欄
  nav: {
    features: "功能特色",
    privacy: "隱私保護",
    blog: "部落格",
    help: "說明中心",
    faq: "常見問題",
    donate: "贊助支持",
    download: "立即下載",
  },

  // 主視覺區
  hero: {
    title: "暢所欲言\n了無痕跡",
    subtitle: "透過去中心化加密技術實現的私密通訊",
    cta: "取得 Vapor",
    platforms: "支援 Android、iOS、Windows、macOS 及 Linux。",
    phone: {
      contact: "05df…a3b1",
      status: "已加密",
      conversation: [
        { from: "them", text: "欸！你有用過 Vapor 嗎？" },
        { from: "me", text: "剛裝好，不用手機號碼欸！" },
        { from: "them", text: "對啊，只要帳戶 ID，完全匿名。" },
        { from: "me", text: "而且全程端對端加密？" },
        { from: "them", text: "沒錯！還有洋蔥路由，誰都追蹤不到。" },
        { from: "me", text: "終於有一個值得信任的通訊軟體了。" },
      ],
    },
  },

  // 產品介紹
  intro: {
    title: "什麼是 Vapor？",
    description:
      "Vapor 是一款端對端加密的通訊軟體 致力於保護您的個人資料 由全球熱衷隱私保護的社群共同打造與維護",
  },

  // 六大隱私特性
  privacyFeatures: [
    {
      title: "無需手機號碼",
      description:
        "使用帳戶 ID 保護您的身份隱私 註冊無需提供手機號碼或電子郵件",
      icon: "🔒",
    },
    {
      title: "零資料外洩風險",
      description: "Vapor 不蒐集您的私人資料 因此不存在外洩的可能",
      icon: "🛡️",
    },
    {
      title: "安全路徑",
      description: "洋蔥路由路徑保護您的對話 免受駭客與竊聽者的侵擾",
      icon: "🧅",
    },
    {
      title: "開放原始碼",
      description:
        "隱私不僅僅是承諾 任何人都可以檢視、審計並為 Vapor 的程式碼做出貢獻",
      icon: "📖",
    },
    {
      title: "社群驅動",
      description:
        "數千個節點由全球社群共同營運 Vapor 由社群打造 為使用者服務",
      icon: "🌍",
    },
    {
      title: "無追蹤器",
      description: "您的資料絕不會被蒐集、追蹤或出售給第三方",
      icon: "🚫",
    },
  ],

  // 三大功能區
  features: [
    {
      title: "暢所欲言",
      description:
        "只有您和對話對象能看到訊息內容 透過端對端加密與限時訊息 盡享自由溝通",
    },
    {
      title: "掌握主控權",
      description:
        "從頭到尾掌控您的訊息 管理加密金鑰或選擇自訂佈景主題——Vapor 讓您全權做主",
    },
    {
      title: "群組隱私保護",
      description:
        "安全的群組與社群聊天室支援 100 人以上 讓您與朋友組織活動輕鬆無負擔",
    },
  ],

  // 功能區手機內容
  featurePhones: {
    chat: {
      name: "7c2e…f904",
      status: "已加密",
      messages: [
        { from: "them", text: "欸，這個真的是私密的嗎？" },
        { from: "me", text: "端對端加密，只有我們看得到。" },
        { from: "them", text: "不用手機號碼？" },
        { from: "me", text: "對啊，只要帳戶 ID 就好。" },
        { from: "them", text: "太酷了！完全沒有任何資料外洩？" },
        { from: "me", text: "零外洩。訊息看完就消失。" },
      ],
      tag: "端對端加密",
    },
    settings: {
      title: "設定",
      items: {
        encryptionKeys: "加密金鑰",
        verified: "已驗證",
        disappearing: "限時訊息",
        onionRouting: "洋蔥路由",
        notifications: "通知",
        theme: "佈景主題",
        themeVal: "淺色",
        linkedDevices: "已連結裝置",
        screenLock: "螢幕鎖定",
        recoveryEmail: "備援信箱",
        set: "已設定",
      },
    },
    group: {
      name: "Vapor 社群",
      members: "100 位成員",
      messages: [
        { from: "9a1f…de07", color: "#00d46a", text: "歡迎大家！這個群組全程加密。" },
        { from: "b4c8…6e3a", color: "#61F78D", text: "100 多人還能保持隱私，太厲害了！" },
        { from: "me", text: "社群功能超棒的。" },
        { from: "e72d…41fc", color: "#00b35a", text: "去中心化又開源，這才是未來！" },
        { from: "me", text: "沒有廣告、沒有追蹤，純粹的隱私。" },
        { from: "9a1f…de07", color: "#00d46a", text: "快把邀請連結分享給朋友吧！" },
      ],
      inputPlaceholder: "輸入訊息...",
    },
  },

  // 號召行動區
  callToAction: {
    title: "無廣告 無追蹤\n絕不妥協",
    description:
      "Vapor 免費且開放原始碼\n由堅信隱私是基本人權的社群共同打造",
    cta: "取得 Vapor",
  },

  // 電子報訂閱
  newsletter: {
    title: "掌握最新動態",
    description: "數位隱私的每一次更新 直接送到您的收件匣",
    placeholder: "輸入您的電子郵件",
    button: "訂閱",
  },

  // 頁腳
  footer: {
    about: "關於我們",
    changelog: "更新日誌",
    privacyPolicy: "隱私權政策",
    terms: "服務條款",
    blog: "部落格",
    faq: "常見問題",
    community: "社群",
    contactUs: "聯絡我們",
    companyName: "Vapor Technology Co., Ltd.",
    address: "105 台北市松山區南京東路四段 50 號 12 樓",
  },
};

export default zhTW;
